import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.3333 6.99935V6.33268C15.3333 5.39926 15.3333 4.93255 15.1517 4.57603C14.9919 4.26243 14.7369 4.00746 14.4233 3.84767C14.0668 3.66602 13.6001 3.66602 12.6667 3.66602H11.3333C10.3999 3.66602 9.9332 3.66602 9.57668 3.84767C9.26308 4.00746 9.00811 4.26243 8.84832 4.57603C8.66667 4.93255 8.66667 5.39926 8.66667 6.33268V6.99935M10.3333 11.5827V15.7493M13.6667 11.5827V15.7493M4.5 6.99935H19.5M17.8333 6.99935V16.3327C17.8333 17.7328 17.8333 18.4329 17.5608 18.9677C17.3212 19.4381 16.9387 19.8205 16.4683 20.0602C15.9335 20.3327 15.2335 20.3327 13.8333 20.3327H10.1667C8.76654 20.3327 8.06647 20.3327 7.53169 20.0602C7.06129 19.8205 6.67883 19.4381 6.43915 18.9677C6.16667 18.4329 6.16667 17.7328 6.16667 16.3327V6.99935",
      stroke: "#1C1D1F",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }